export default __webpack_public_path__ + "static/media/library.8fbc026c.svg";